<div class="history">
	<ng-content select="app-quote-drawer-heading"></ng-content>
	<div class="history__content">
		<!-- Empty state when no history exists -->
		<div
			*ngIf="!(hasHistory$ | async)"
			class="history__empty-state"
		>
			<p class="history__empty-state-text">
				No historical brand or call source data available yet.
			</p>
		</div>

		<!-- Display history when available -->
		<div
			*ngIf="hasHistory$ | async"
			class="history__list"
		>
			<h3 class="history__list-heading">Historical Brand & Call Source</h3>
			<p class="history__list-subheading">Pet Parent: {{ contactFullName$ | async }}</p>

			<div class="history__items">
				<div
					*ngFor="let item of historyItems$ | async; let i = index"
					class="history__item"
					[class.history__item--most-recent]="i === 0"
				>
					<div class="history__item-header">
						<span class="history__item-timestamp">
							{{ item.addedOn | date: 'short' }}
						</span>
						<span
							class="history__item-label"
							*ngIf="i === 0"
						>
							Most Recent
						</span>
					</div>
					<div class="history__item-content">
						<div class="history__item-field">
							<strong class="history__item-field-label">Brand:</strong>
							<span class="history__item-field-value">{{ item.brand }}</span>
						</div>
						<div class="history__item-field">
							<strong class="history__item-field-label">Call Source:</strong>
							<span class="history__item-field-value">{{ item.callSourceName }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
